import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';

import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { TranslateService } from './core/services/translate.service';
import { provideAnimations } from '@angular/platform-browser/animations';

import { MarkdownModule } from 'ngx-markdown';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

pdfDefaultOptions.assetsFolder = 'assets';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideAppInitializer(() => {
      const translateService = inject(TranslateService);
      return translateService.getData('/i18n/');
    }),
    provideAnimations(),
    importProvidersFrom(MarkdownModule.forRoot()), provideClientHydration(withEventReplay()),
  ],
};
